import $ from "jquery";
export FontUtil from "./FontUtil";


/**
* 数字に３桁区切りでカンマを入れて文字列で返す
* @return {string} - 変換後の文字列
*/
export const formatNumToSeparatedString = (value) => {
  return String(value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};

export const disableScroll = () => {
  console.log("%c[disableScroll]", "color: gray; font-weight: bold;");
  // $(window, document).on("touchmove.noScroll", function(e) {
  //   e.preventDefault();
  // });

  // const scroll_event = "onwheel" in document ? "wheel" : "onmousewheel" in document ? "mousewheel" : "DOMMouseScroll";
  const scroll_event =  "DOMMouseScroll";
  $(window, document).on(scroll_event, e => { e.preventDefault(); });
};

export const enableScroll = () => {
  console.log("%c[enableScroll]", "color: gray; font-weight: bold;");
  // $(window, document).off("touchmove.noScroll");
  // const scroll_event = "onwheel" in document ? "wheel" : "onmousewheel" in document ? "mousewheel" : "DOMMouseScroll";
  const scroll_event =  "DOMMouseScroll";
  $(window, document).off(scroll_event);
};



// WEBPACK FOOTER //
// ./src/js/utils/index.js